<template>
  <div class ="BadUrl">
    <h1>404 page not found</h1>
  </div>
</template>

<script>

  export default {
    
  };
</script>